import React, {PureComponent} from 'react';
import { Redirect } from "react-router";

import {withTranslation} from 'react-i18next';

import LinkedAccountList from "./List";
import PageTitle from "../../Commons/PageTitle";
import UserContext from '../../../context/user-context';

class PersonnifyAccounts extends PureComponent {
    static contextType = UserContext;

    render() {
        if (this.context.user.infos != null && this.context.user.infos.can_personify !== undefined && !this.context.user.infos.can_personify) {
            return <Redirect to={{pathname: "/"}}/>;
        }

        return (
            <div className="container container--larger">
                <div className="row flex flex--wrap">
                    <div className="col-md-6">
                        <PageTitle title={this.props.t("linkedaccounts.title")}/>
                    </div>
                </div>

                <div>
                    <LinkedAccountList
                        personnification={true}/>
                </div>
            </div>

        );
    }
}

export default withTranslation()(PersonnifyAccounts);
